import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-114" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-115" data-mp="1dx9rbo8dwo6a">
        <SectionHeading id="modules-title" data-id="element-116" data-mp="1dudtdzwjdzhu">The {totalVolumes} Comprehensive Volumes</SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-117" data-mp="2bi5z5i9nu911">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-electric/25 bg-panel p-6 shadow-lg shadow-black/30" data-id="element-118" data-mp="21krltrj1a0cy" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-119" data-mp="1nta9qhwrbsff">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-electric text-white" data-id="element-120" data-mp="18x2s9pcqh53u">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="1dvmc9k7ro6tk" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-electric" data-id="element-122" data-mp="1050q9mn0ngrg">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-bold leading-tight text-white" data-id="element-123" data-mp="14w90um031867">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink" data-id="element-124" data-mp="q7w7lwsdq3fe">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}